export enum ShowTypes {
    Series = "Series",
    Movie = "Movie",
}